<h1 mat-dialog-title *ngIf="!isLoading" xmlns="http://www.w3.org/1999/html">Edit Business Overview</h1>
<div id="spinnerContainer" *ngIf="isLoading">
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</div>
<div *ngIf="!isLoading">
  <mat-dialog-content [formGroup]="formGroup">
    <fieldset class="fieldset-container">
      <legend>Business Title</legend>
      <p>
        <mat-form-field class="inputs">
          <input matInput
                 placeholder="Business Name *"
                 formControlName="title">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="inputs">
          <input matInput
                 placeholder="Doing Business As"
                 formControlName="doBusAs">
        </mat-form-field>
      </p>
    </fieldset>
    <fieldset class="fieldset-container" style="padding-bottom: 5px">
      <legend>Address</legend>
      <!--style="padding-left: 0; padding-right: 0; padding-bottom: 0"-->
      <!--style="margin-left: 0; margin-right: 0; margin-bottom: 0"-->
      <mat-accordion>
        <!-- Business Address Section-->
        <mat-expansion-panel (opened)="businessPanelOpened()" (closed)="businessPanelClosed()" [expanded]="businessPanelIsActive">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Business Address
            </mat-panel-title>
            <mat-panel-description>
              {{businessPanelText}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <h2></h2>
          <p>
            <mat-form-field class="inputs">
              <input matInput
                     placeholder="Street 1 *"
                     formControlName="street1">
            </mat-form-field>
          </p>
          <p>
            <mat-form-field class="inputs">
              <input matInput
                     placeholder="Street 2"
                     formControlName="street2">
            </mat-form-field>
          </p>
          <p class="input address_line_row">
            <mat-form-field class="address_row_item cityField">
              <input matInput
                     placeholder="City *"
                     formControlName="city">
            </mat-form-field>
            <mat-form-field *ngIf="states.length" class="address_row_item">
              <mat-select formControlName="stateProvince" placeholder="Select State *">
                <mat-option value="">None</mat-option>
                <mat-option *ngFor="let state of states" value="{{state.stateCode}}">{{state.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="!states.length" class="address_row_item">
              <input matInput
                     placeholder="Enter State"
                     formControlName="stateProvince">
            </mat-form-field>
            <mat-form-field class="address_row_item">
              <input matInput
                     placeholder="{{postalCodePlaceHolder}}"
                     formControlName="postalCode">
            </mat-form-field>
            <mat-form-field>
              <mat-select [id]="1" formControlName="country" placeholder="Select Country"
                          (selectionChange)="countryChange($event)">
                <mat-option value="">None</mat-option>
                <mat-option *ngFor="let country of countries" value="{{country.countryCodeIso2.trim()}}">
                  {{country.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </p>
        </mat-expansion-panel>
        <!-- Mailing Address Section-->
        <mat-expansion-panel  (opened)="mailingPanelOpened()" (closed)="mailingPanelClosed()" [expanded]="!businessPanelIsActive">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Mailing Address
            </mat-panel-title>
            <mat-panel-description>
              &nbsp;&nbsp;{{mailingPanelText}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-checkbox formControlName="addressSame" (change)="addressSameChange($event)">Is same as business address</mat-checkbox>
          <div id="mailingAddress">
            <p>
              <mat-form-field class="inputs">
                <input matInput
                       placeholder="Street 1"
                       formControlName="mailingStreet1">
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="inputs">
                <input matInput
                       placeholder="Street 2"
                       formControlName="mailingStreet2">
              </mat-form-field>
            </p>
            <p class="inputs">
              <mat-form-field id="cityField">
                <input matInput
                       placeholder="City"
                       formControlName="mailingCity">
              </mat-form-field>
              <mat-form-field *ngIf="statesMailing.length" class="address_row_item">
                <mat-select formControlName="mailingStateProvince" placeholder="Select State">
                  <mat-option value="">None</mat-option>
                  <mat-option *ngFor="let state of statesMailing" value="{{state.stateCode}}">{{state.description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="!statesMailing.length" class="address_row_item">
                <input matInput
                       placeholder="Enter State"
                       formControlName="mailingStateProvince">
              </mat-form-field>
              <mat-form-field id="postalField">
                <input matInput
                       placeholder="{{postalCodePlaceHolder}}"
                       formControlName="mailingPostalCode">
              </mat-form-field>
              <mat-form-field>
                <mat-select [id]="2" formControlName="mailingCountry" placeholder="Select Country"
                            (selectionChange)="countryChange($event)">
                  <mat-option value="">None</mat-option>
                  <mat-option *ngFor="let country of countries" value="{{country.countryCodeIso2.trim()}}">
                    {{country.description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </fieldset>
    <fieldset class="fieldset-container">
      <legend>Contact and Website</legend>
      <p class="inputs">
        <mat-form-field id="phoneField">
          <input #phone
                 matInput
                 placeholder="Phone"
                 formControlName="phone"
                 maxlength="14"
                 (blur)="phoneFieldBlur('phone')"
                 (keyup)="phoneFieldKeyUp($event, 'phone', phone)">
        </mat-form-field>
        <mat-form-field id="faxField">
          <input #fax
                 matInput
                 placeholder="Fax"
                 formControlName="fax"
                 maxlength="14"
                 (blur)="phoneFieldBlur('fax')"
                 (keyup)="phoneFieldKeyUp($event, 'fax', fax)">
        </mat-form-field>
      </p>
      <p class="inputs">
        <mat-form-field id="websiteField">
          <input matInput
                 placeholder="Website"
                 formControlName="webAddress">
        </mat-form-field>
        <mat-form-field id="emailField">
          <input matInput
                 placeholder="Email"
                 formControlName="email">
        </mat-form-field>
      </p>
    </fieldset>
    <fieldset class="fieldset-container">
      <legend>Additional Location Info</legend>
      <div id="locationOnField">
        <mat-checkbox formControlName="isLocatedOnField">Business is Located on Airport</mat-checkbox>
        <p *ngIf="formGroup.value.isLocatedOnField">
          <mat-form-field>
            <mat-select formControlName="locationOnField">
              <mat-option value="">None</mat-option>
              <mat-option value="N">N</mat-option>
              <mat-option value="NE">NE</mat-option>
              <mat-option value="E">E</mat-option>
              <mat-option value="SE">SE</mat-option>
              <mat-option value="S">S</mat-option>
              <mat-option value="SW">SW</mat-option>
              <mat-option value="W">W</mat-option>
              <mat-option value="NW">NW</mat-option>
              <mat-option value="CTR">Cntr</mat-option>
            </mat-select>
          </mat-form-field>
        </p>
      </div>
      <p>
        <mat-form-field class="inputs" id="locDescField">
        <textarea matInput formControlName="locationDesc"
                  placeholder="Location Description (max 50 characters)"></textarea>
        </mat-form-field>
      </p>
    </fieldset>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="close()">Cancel</button>
  </mat-dialog-actions>
</div>
